import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { Toast } from "./../UI/toast/Toast";
import { sendPropertiesCredentialsToN8n } from "../../helpers/api/condominium";

const NotifyCredentialsModal = ({ isOpen, toggle, selectedCondominium, propertyIds, propertyName }) => {
  const [sendingToN8n, setSendingToN8n] = useState(false);

  const handleSendToN8nConfirm = async () => {
    setSendingToN8n(true);
    try {
      const response = await sendPropertiesCredentialsToN8n(selectedCondominium, propertyIds);
      Toast.fire({
        type: "success",
        title: response.message || "Credenciales enviadas exitosamente.",
      });
      toggle();
    } catch (err) {
      Toast.fire({
        type: "error",
        title: err.message || "Error al enviar credenciales.",
      });
    } finally {
      setSendingToN8n(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Notificar accesos por correo
      </ModalHeader>
      <ModalBody>
        <p className="fs--1 text-muted mb-3">
          {propertyName
            ? `¿Está seguro de que desea notificar las credenciales de acceso por correo electrónico al propietario del inmueble "${propertyName}"?`
            : "¿Está seguro de que desea notificar las credenciales de acceso por correo electrónico a todos los propietarios?"}
        </p>
        <Alert color="info" className="shadow-sm fs--1 mb-0 d-flex align-items-center">
          <FontAwesomeIcon icon={faKey} className="mr-2" />
          <span>
            Este proceso enviará las credenciales temporales de acceso a los correos electrónicos registrados de cada propietario.
          </span>
        </Alert>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          size="sm"
          onClick={toggle}
          disabled={sendingToN8n}
        >
          Cancelar
        </Button>
        <Button
          color="primary"
          size="sm"
          onClick={handleSendToN8nConfirm}
          disabled={sendingToN8n}
        >
          {sendingToN8n ? "Enviando..." : "Sí, notificar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

NotifyCredentialsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  selectedCondominium: PropTypes.string.isRequired,
  propertyIds: PropTypes.arrayOf(PropTypes.number),
  propertyName: PropTypes.string,
};

export default NotifyCredentialsModal;
